import { useContext, useEffect, useState } from 'react';
import { SettingsNavItem } from 'common/settings-layout';
import { Spinner } from 'common/spinner';
import { VaultAvatar } from 'common/vault-avatar';
import { AppContext } from 'context';
import { isLockedVault, isOwner, isRestrictedVault } from 'helpers/utils';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { goToPage, RouteName } from 'routes';

type VaultSettingsNavProps = {
  currentVaultId: number;
};

// The vaults whose settings the user may open (owned or edited), to move
// between them. Vaults they only view or contribute to aren't listed.
const NAV_PAGE_SIZE = 50;

const VaultSettingsNav = ({ currentVaultId }: VaultSettingsNavProps) => {
  const {
    state: {
      logged,
      data: { user },
    },
  } = useContext(AppContext);
  const [vaults, setVaults] = useState<VaultType[] | undefined>(undefined);

  useEffect(() => {
    if (!logged) return;
    VaultsController.getManagedVaults(NAV_PAGE_SIZE)
      .then(setVaults)
      .catch(() => setVaults([]));
  }, [logged]);

  const roleLabel = (vault: VaultType) =>
    isOwner(user, vault) ? 'Owner' : 'Editor';

  if (!vaults) return <Spinner />;

  return (
    <>
      {vaults.map((vault) => (
        <SettingsNavItem
          key={vault.id}
          active={vault.id === currentVaultId}
          avatar={
            <VaultAvatar
              isSmall
              imageURL={vault.coverThumbnailUrl}
              isLockedOrRestrictedVault={
                isLockedVault(vault) || isRestrictedVault(vault)
              }
            />
          }
          title={vault.title}
          subtitle={roleLabel(vault)}
          onClick={() => goToPage(RouteName.VaultSettings, { id: vault.id })}
        />
      ))}
    </>
  );
};

export { VaultSettingsNav };
